
export const PageContainer = ({ children, className = "" }) => {
  return (
    <div
      className={[
        "relative w-full",
        "max-w-[650px] mx-auto", 
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
};
